import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Home from '../views/Home.vue'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: 'zone-handler',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
      beforeEnter(to, from, next) {
        console.log("home", store.state.agentId);
        store.commit('setFreshSearch');
        store.commit('setError', to.params.error);

        next();
      }
    },

    {
      path: '/a/:agentId',
      name: 'agent-affiliated-home',
      component: Home,
      props: true,
      beforeEnter(to, from, next) {
        console.log("home2", to.params.agentId);
        store.commit('setAgentId', to.params.agentId);
        store.commit('setFreshSearch');
        store.commit('setError', to.params.error);
        next("/");  // Forward to the root (Home page)
      }
    },
    {
      path: '/location/:address/a/:agentId',
      name: 'agent-affiliated-location',
      props: true,
      component: () => import('../views/ProductSelection.vue'),
      beforeEnter(to, from, next) {
        const address = to.params.address;
        console.log('location2', to.params.agentId);
        store.commit('setAgentId', to.params.agentId);
        next(`/location/${address}`);  // Forward to the /location/:address
      }
    },
    {
      path: '/location/:address',
      name: 'location',
      props: true,
      component: () => import('../views/ProductSelection.vue'),
      beforeEnter(to, from, next) {
        store.commit('setAddress', to.params.address)
        next()
      }
    },
    {
      path: '/location/:address/all',
      name: 'location-all',
      props: true,
      component: () => import('../views/ProductShow.vue'),
      beforeEnter(to, from, next) {
        store.commit('setAddress', to.params.address)
        store.commit('setCoordsFromMap', {
          lat: to.query.lat,
          lng: to.query.lng
        })
        next()
      }
    },
    {
      path: '/purchase',
      name: 'purchase',
      props: true,
      component: () => import('../views/Purchase.vue'),
      beforeEnter(to, from, next) {
        store.commit('setProduct', to.params.product)
        store.commit('setProductIds', to.params.productIds)
        store.commit('setFullAddress', to.params.address)
        store.commit('setUnitNumber', to.params.unitNumber)
        store.commit('setBuildingName', to.params.buildingName)
        store.commit('setAddressCode', to.params.addressCode)
        store.commit('setInstallType', to.params.installType)
        next()
      }
    },
    {
      path: '/complete',
      name: 'complete',
      props: true,
      component: () => import('../views/Complete.vue'),
      beforeEnter(to, from, next) {
        store.commit('setOrderNumber', to.params.orderNumber)
        next()
      }
    },
    {
      path: '/invite_sent',
      name: 'inviteSent',
      props: true,
      component: () => import('../views/InviteSent.vue'),
      beforeEnter(to, from, next) {
        store.commit('setOrderNumber', to.params.orderNumber)
        next()
      }
    },
    {
      path: '/upgrade_sent',
      name: 'upgradeRequestSent',
      props: true,
      component: () => import('../views/UpgradeRequestSent.vue')
    },
    {
      path: '/legal',
      name: 'legal',
      props: true,
      component: () => import('../views/Legal.vue')
    },
    {
      path: '/legal/:type/:question',
      name: 'legal-question',
      props: true,
      component: () => import('../views/LegalQuestion.vue')
    },
    {
      path: '/notices',
      name: 'notices',
      props: true,
      component: () => import('../views/Notices.vue')
    },
    {
      path: '/faq',
      beforeEnter() {
        window.location.href = "http://help.cybersmart.co.za";
      }
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      props: true,
      component: () => import('../views/ContactUs.vue')
    },
    {
      path: '/query_sent',
      name: 'querySent',
      props: true,
      component: () => import('../views/QuerySent.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      props: true,
      component: () => import('../views/Blog.vue')
    },
    {
      path: '/about',
      name: 'about-us',
      component: () => import('../views/About.vue')
    },

    {
      path: '/blog/:id',
      name: 'blog-entry',
      props: true,
      component: () => import('../views/BlogEntry.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('../views/PrivacyPolicy.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
